import React from 'react'
import { createUseStyles } from 'react-jss'
import ButtonCta from './ButtonCta'

const useStyles = createUseStyles(theme => ({
  container: {
    boxSizing: 'border-box',
    padding: '10vh 15px',
    margin: '0 auto',
    width: '100%',
    maxWidth: '800px',
  },
  containerInner: {
    boxSizing: 'border-box',
    padding: '70px 50px',
    backgroundColor: '#F5F5F5',
    borderRadius: '30px',
  },
  title: {
    color: '#EE2049',
    fontSize: '38px',
    lineHeight: '1.2',
    fontWeight: 700,
    fontFamily: 'TTRounds',
    textAlign: 'center',
    marginBottom: '30px',
    marginTop: 0,
    maxWidth: '520px',
    marginLeft: 'auto',
    marginRight: 'auto',
    '@media (max-width: 600px)': {
      fontSize: '32px',
      marginBottom: '10px',
    },
  },
  topTitle: {
    color: '#EE2049',
    fontSize: '54px',
    lineHeight: '54px',
    fontWeight: 700,
    fontFamily: 'TTRounds',
    textAlign: 'center',
    marginBottom: 9,
    marginTop: 0,
    maxWidth: '520px',
    marginLeft: 'auto',
    marginRight: 'auto',
    '@media (max-width: 600px)': {
      fontSize: '40px',
      marginBottom: '10px',
    },
  },
  details: {
    color: theme.colors.textColor,
    fontSize: '18px',
    lineHeight: '25px',
    fontWeight: 'normal',
    fontFamily: 'AvenirNextLTPro',
    textAlign: 'center',
    letterSpacing: '0.02em',
    marginTop: 0,
    marginBottom: '35px',
    maxWidth: '520px',
    marginLeft: 'auto',
    marginRight: 'auto',
    fontWeight: 300,
    '@media (max-width: 600px)': {
      marginBottom: '74px',
    },
  },
  buttons: {
    textAlign: 'center',
    '@media (max-width: 600px)': {
      '& a': {
        display: 'block',
      },
    },
    '& a + a': {
      marginLeft: '20px',
      '@media (max-width: 600px)': {
        marginLeft: '0',
        marginTop: '20px',
      },
    },
  },
}))

const NotFoundBox = props => {
  const classes = useStyles()
  const { title, details, buttononetext, buttononeurl, buttontwotext, buttontwourl } = props

  return (
    <div className={classes.container}>
      <div className={classes.containerInner}>
        <div className={classes.topTitle}>404</div>
        <div className={classes.title}>{title}</div>
        <div className={classes.details}>{details}</div>
        <div className={classes.buttons}>
          <ButtonCta primary text={buttononetext} url={buttononeurl} />
          <ButtonCta secondary text={buttontwotext} url={buttontwourl} />
        </div>
      </div>
    </div>
  )
}

export default NotFoundBox
